import { Suspense, lazy } from 'react';

import { DeviceInfo } from '@ezugi/utils';

const DesktopHeader = lazy(() => import('../../components/DesktopGameHeader'));
const MobileHeader = lazy(() => import('../../components/MobileHeader'));

export type GameHeaderProps = {
  className?: string;
  newDesign?: boolean;
};

const GameHeader = ({ className, newDesign }: GameHeaderProps) => (
  <Suspense fallback={null}>
    {DeviceInfo.isHandheld ? (
      <MobileHeader className={className} />
    ) : (
      <DesktopHeader className={className} newDesign={newDesign} />
    )}
  </Suspense>
);

export default GameHeader;
